import {
  DETECTION_RIGHTEAR_SUBMIT,
  DETECTION_LEFTEAR_SUBMIT,
  DETECTION_CLEAR_RESULT,
  DETECTION_START,
  DETECTION_CLOSE_MODAL,
  DETECTION_SENDFORM_OPEN_MODAL,
  DETECTION_SENDFORM_CLOSE_MODAL,
  DETECTION_RULE_OPEN_MODAL,
  DETECTION_RULE_CLOSE_MODAL,
  DETECTION_SENDED_RESULT,
} from '../actions/Detection.js';

import question1Video from '../static/videos/lifeQuestionQ1.mp4';
import question2Video from '../static/videos/lifeQuestionQ2.mp4';
import question3Video from '../static/videos/lifeQuestionQ3.mp4';
import question4Video from '../static/videos/lifeQuestionQ4.mp4';
import question5Video from '../static/videos/lifeQuestionQ5.mp4';

import R400020 from '../static/audios/4000_r_20.mp3';
import R400030 from '../static/audios/4000_r_30.mp3';
import R400040 from '../static/audios/4000_r_40.mp3';
import R400050 from '../static/audios/4000_r_50.mp3';
import R400060 from '../static/audios/4000_r_60.mp3';
import R400070 from '../static/audios/4000_r_70.mp3';
import R200020 from '../static/audios/2000_r_20.mp3';
import R200030 from '../static/audios/2000_r_30.mp3';
import R200040 from '../static/audios/2000_r_40.mp3';
import R200050 from '../static/audios/2000_r_50.mp3';
import R200060 from '../static/audios/2000_r_60.mp3';
import R200070 from '../static/audios/2000_r_70.mp3';
import R50020 from '../static/audios/500_r_20.mp3';
import R50030 from '../static/audios/500_r_30.mp3';
import R50040 from '../static/audios/500_r_40.mp3';
import R50050 from '../static/audios/500_r_50.mp3';
import R50060 from '../static/audios/500_r_60.mp3';
import R50070 from '../static/audios/500_r_70.mp3';
import R100020 from '../static/audios/1000_r_20.mp3';
import R100030 from '../static/audios/1000_r_30.mp3';
import R100040 from '../static/audios/1000_r_40.mp3';
import R100050 from '../static/audios/1000_r_50.mp3';
import R100060 from '../static/audios/1000_r_60.mp3';
import R100070 from '../static/audios/1000_r_70.mp3';
// Left ear sound
import L400020 from '../static/audios/4000_l_20.mp3';
import L400030 from '../static/audios/4000_l_30.mp3';
import L400040 from '../static/audios/4000_l_40.mp3';
import L400050 from '../static/audios/4000_l_50.mp3';
import L400060 from '../static/audios/4000_l_60.mp3';
import L400070 from '../static/audios/4000_l_70.mp3';
import L200020 from '../static/audios/2000_l_20.mp3';
import L200030 from '../static/audios/2000_l_30.mp3';
import L200040 from '../static/audios/2000_l_40.mp3';
import L200050 from '../static/audios/2000_l_50.mp3';
import L200060 from '../static/audios/2000_l_60.mp3';
import L200070 from '../static/audios/2000_l_70.mp3';
import L50020 from '../static/audios/500_l_20.mp3';
import L50030 from '../static/audios/500_l_30.mp3';
import L50040 from '../static/audios/500_l_40.mp3';
import L50050 from '../static/audios/500_l_50.mp3';
import L50060 from '../static/audios/500_l_60.mp3';
import L50070 from '../static/audios/500_l_70.mp3';
import L100020 from '../static/audios/1000_l_20.mp3';
import L100030 from '../static/audios/1000_l_30.mp3';
import L100040 from '../static/audios/1000_l_40.mp3';
import L100050 from '../static/audios/1000_l_50.mp3';
import L100060 from '../static/audios/1000_l_60.mp3';
import L100070 from '../static/audios/1000_l_70.mp3';

const questionList = [{
  key: 1,
  name: 'question1',
  video: question1Video,
  s3Path: 'https://s3-ap-northeast-1.amazonaws.com/clinicoapp-media/lifeQuestionQ1.mp4',
  streaming: 'http://125.227.156.222/videos/lifeQuestionQ1.mp4',
  word: '是否在和他人對話中無法聽清楚',
}, {
  key: 2,
  name: 'question2',
  video: question2Video,
  s3Path: 'https://s3-ap-northeast-1.amazonaws.com/clinicoapp-media/lifeQuestionQ2.mp4',
  streaming: 'http://125.227.156.222/videos/lifeQuestionQ2.mp4',
  word: '是否在群眾對話中無法聽清楚',
}, {
  key: 3,
  name: 'question3',
  video: question3Video,
  s3Path: 'https://s3-ap-northeast-1.amazonaws.com/clinicoapp-media/lifeQuestionQ3.mp4',
  streaming: 'http://125.227.156.222/videos/lifeQuestionQ3.mp4',
  word: '是否無法聽清楚遠處的聲音',
}, {
  key: 4,
  name: 'question4',
  video: question4Video,
  s3Path: 'https://s3-ap-northeast-1.amazonaws.com/clinicoapp-media/lifeQuestionQ4.mp4',
  streaming: 'http://125.227.156.222/videos/lifeQuestionQ4.mp4',
  word: '是否無法在嘈雜的環境中聽清楚聲音',
}, {
  key: 5,
  name: 'question5',
  video: question5Video,
  s3Path: 'https://s3-ap-northeast-1.amazonaws.com/clinicoapp-media/lifeQuestionQ5.mp4',
  streaming: 'http://125.227.156.222/videos/lifeQuestionQ5.mp4',
  word: '是否無法聽清楚電視或收音機的正常音量',
}];

const testList = [{
  key: 1,
  frequency: 4000,
}, {
  key: 2,
  frequency: 2000,
}, {
  key: 3,
  frequency: 500,
}, {
  key: 4,
  frequency: 1000,
}];

const rightSoundList = [{
  20: R400020,
  30: R400030,
  40: R400040,
  50: R400050,
  60: R400060,
  70: R400070,
}, {
  20: R200020,
  30: R200030,
  40: R200040,
  50: R200050,
  60: R200060,
  70: R200070,
}, {
  20: R50020,
  30: R50030,
  40: R50040,
  50: R50050,
  60: R50060,
  70: R50070,
}, {
  20: R100020,
  30: R100030,
  40: R100040,
  50: R100050,
  60: R100060,
  70: R100070,
}];

const leftSoundList = [{
  20: L400020,
  30: L400030,
  40: L400040,
  50: L400050,
  60: L400060,
  70: L400070,
}, {
  20: L200020,
  30: L200030,
  40: L200040,
  50: L200050,
  60: L200060,
  70: L200070,
}, {
  20: L50020,
  30: L50030,
  40: L50040,
  50: L50050,
  60: L50060,
  70: L50070,
}, {
  20: L100020,
  30: L100030,
  40: L100040,
  50: L100050,
  60: L100060,
  70: L100070,
}];

export default (state = {
  questionList,
  testList,
  rightSoundList,
  leftSoundList,
  rightResult: [],
  leftResult: [],
  isShownModal: false,
  isShownSendFormModal: false,
  isShownRuleModal: false,
}, action) => {
  switch (action.type) {
    case DETECTION_SENDED_RESULT:
      return Object.assign({}, state, {
        isShownSendFormModal: false,
      });

    case DETECTION_RIGHTEAR_SUBMIT:
      return Object.assign({}, state, {
        rightResult: [
          ...state.rightResult,
          20 + (action.level - 1) * 10,
        ],
      });

    case DETECTION_LEFTEAR_SUBMIT:
      return Object.assign({}, state, {
        leftResult: [
          ...state.leftResult,
          20 + (action.level - 1) * 10,
        ],
      });

    case DETECTION_CLEAR_RESULT:
      return Object.assign({}, state, {
        leftResult: [],
        rightResult: [],
      });

    case DETECTION_START:
      return Object.assign({}, state, {
        isShownModal: true,
      });

    case DETECTION_CLOSE_MODAL:
      return Object.assign({}, state, {
        isShownModal: false,
      });

    case DETECTION_SENDFORM_OPEN_MODAL:
      return Object.assign({}, state, {
        isShownSendFormModal: true,
      });

    case DETECTION_SENDFORM_CLOSE_MODAL:
      return Object.assign({}, state, {
        isShownSendFormModal: false,
      });

    case DETECTION_RULE_OPEN_MODAL:
      return Object.assign({}, state, {
        isShownRuleModal: true,
      });

    case DETECTION_RULE_CLOSE_MODAL:
      return Object.assign({}, state, {
        isShownRuleModal: false,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/Detection.js